export default __webpack_public_path__ + "static/legacy-mob-e66dc38ead4588c47f413e1e11be6ee0.jpg";